import { SubscriptionPlans } from './SubscriptionPlans';
import { useAccess } from '../access';

export function SubscriptionTab() {
  const { error } = useAccess();

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-4">
          Subscription Plans
        </h2>
        {error && (
          <div className="p-4 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg">
            <p className="text-red-700 dark:text-red-300">
              We're having trouble loading your subscription information. Please refresh the page or
              try again later.
            </p>
          </div>
        )}
      </div>

      <SubscriptionPlans />
    </div>
  );
}
